import "./PSwitch.scss"

import { Spinner } from "@shopify/polaris"
import classNames from "classnames"

export interface PSwitchProps {
  disabled?: boolean
  loading?: boolean
  type?: "default" | "pill"
  value: boolean
  onChange: (value: boolean) => void
}
export const PSwitch = (props: PSwitchProps) => {
  const { value, disabled, loading = false, onChange, type = "default" } = props
  return (
    <button
      className={classNames("PSwitch", {
        "PSwitch--pill": type === "pill",
        "PSwitch--open": value && !loading,
        "PSwitch--disabled": disabled && !loading,
        "PSwitch--loading": loading,
      })}
      disabled={disabled || loading}
      onClick={() => {
        if (!loading) {
          onChange(!value)
        }
      }}
    >
      {loading ? (
        <div className="PSwitch__spinner">
          <Spinner size="small" />
        </div>
      ) : (
        <div
          className={classNames("PSwitch__dot", {
            "PSwitch__dot--open": value,
            "PSwitch__dot--disabled": disabled || loading,
          })}
        ></div>
      )}
    </button>
  )
}
